var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var heading = require('../../components/heading');
var equipmentDiagram = require('../../equipment/components/equipmentDiagram');

var diagramElement = {};

function normalizeEquipmentRid(rawValue) {
  var trimmed;
  if (typeof rawValue === 'string') {
    trimmed = rawValue.trim();
  } else if (rawValue != null) {
    trimmed = String(rawValue).trim();
  } else {
    trimmed = '';
  }

  if (!trimmed) {
    return { normalized: null, hasValue: false, valid: true };
  }

  var prefixed = trimmed.charAt(0) === '#' ? trimmed : ('#' + trimmed);
  var valid = /^#\d+:\d+$/.test(prefixed);
  return { normalized: valid ? prefixed : null, hasValue: true, valid: valid };
}

diagramElement.oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element || {};
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.equipmentRecord = prop(null);
  ctrl.loading = prop(false);
  ctrl.error = prop(null);
  ctrl.lastLoadedRid = null;
  ctrl.pendingRid = null;
  ctrl.requestToken = 0;
  ctrl.diagram = prop();
  ctrl.redrawDiagram = prop(false);
  ctrl.instanceId = Math.random().toString(36).slice(2);
  ctrl.canvasId = 'diagram-element-canvas-' + ctrl.instanceId;
  ctrl.groupingButtonId = 'diagram-element-grouping-' + ctrl.instanceId;
  ctrl.noop = function () {};

  ctrl.loadEquipmentDiagram = function () {
    var ridState = normalizeEquipmentRid(ctrl.element && ctrl.element.equipmentRid);
    if (!ridState.hasValue) {
      ctrl.requestToken += 1;
      ctrl.pendingRid = null;
      ctrl.loading(false);
      ctrl.equipmentRecord(null);
      ctrl.error(null);
      ctrl.lastLoadedRid = null;
      return Promise.resolve();
    }
    if (!ridState.valid) {
      ctrl.requestToken += 1;
      ctrl.pendingRid = null;
      ctrl.loading(false);
      ctrl.equipmentRecord(null);
      ctrl.error('Invalid equipment RID format. Use "#<clusterId>:<recordId>".');
      ctrl.lastLoadedRid = null;
      return Promise.resolve();
    }
    if (ctrl.lastLoadedRid === ridState.normalized) {
      return Promise.resolve();
    }
    if (ctrl.pendingRid === ridState.normalized) {
      return Promise.resolve();
    }

    ctrl.loading(true);
    ctrl.error(null);
    ctrl.pendingRid = ridState.normalized;
    ctrl.requestToken += 1;
    var currentToken = ctrl.requestToken;
    return loaders.requestWithLoader({
      loader: 'background',
      background: true,
      method: 'GET',
      url: '/api/v1/equipment/' + ridState.normalized.slice(1)
    })
      .then(function (equipmentRecord) {
        if (currentToken !== ctrl.requestToken) return;
        ctrl.equipmentRecord(equipmentRecord || null);
        ctrl.lastLoadedRid = ridState.normalized;
      })
      .catch(function (error) {
        if (currentToken !== ctrl.requestToken) return;
        ctrl.equipmentRecord(null);
        ctrl.lastLoadedRid = null;
        ctrl.error((error && error.message) || 'Unable to load equipment diagram preview.');
      })
      .finally(function () {
        if (currentToken !== ctrl.requestToken) return;
        ctrl.pendingRid = null;
        ctrl.loading(false);
        m.redraw();
      });
  };

  ctrl.loadEquipmentDiagram();
};

diagramElement.onbeforeupdate = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element || {};
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.loadEquipmentDiagram();
};

diagramElement.view = function () {
  var ctrl = this;
  var elementRecord = ctrl.element || {};

  return m('div.f3', [
    m(heading, {
      label: elementRecord.name,
      class: 'f1 mb2',
      element: elementRecord,
      parentReinitialize: ctrl.parentReinitialize,
      dashboardCallback: ctrl.dashboardCallback
    }),
    (function () {
      var ridState = normalizeEquipmentRid(elementRecord.equipmentRid);
      if (!ridState.hasValue) {
        return m('div.moon-gray.mt2', 'Set an Equipment RID to show a diagram preview.');
      }
      if (!ridState.valid) {
        return m('div.red.mt2', 'Invalid equipment RID format.');
      }
      if (ctrl.loading()) {
        return m('div.moon-gray.mt2', 'Loading diagram preview...');
      }
      if (ctrl.error()) {
        return m('div.red.mt2', ctrl.error());
      }
      if (!ctrl.equipmentRecord()) {
        return m('div.moon-gray.mt2', 'No diagram data available for this equipment.');
      }

      return m('div.relative.mt2.ba.b--mid-gray.br2.overflow-hidden', {
        style: {
          height: '360px'
        }
      }, [
        m('div.h-100.w-100', {
          style: {
            pointerEvents: 'auto',
            touchAction: 'none'
          }
        }, [
          m(equipmentDiagram, {
            equipmentRecord: ctrl.equipmentRecord,
            diagram: ctrl.diagram,
            redrawDiagram: ctrl.redrawDiagram,
            parentReinitialize: ctrl.noop,
            parentReinitializeAndRedraw: ctrl.noop,
            forceReadOnly: true,
            canvasId: ctrl.canvasId,
            groupingButtonId: ctrl.groupingButtonId
          })
        ])
      ]);
    })()
  ]);
};

module.exports = diagramElement;
